//@flow
import React, { Component } from "react";
import type { ProductType } from "../types/product.js";
import type { ProductPurchasability } from "../types/publicpurchasable";
import ButtonAddToCart from "../button-add-to-cart";
import ButtonShopInMax from "../button-shop-in-max";
import { ButtonLoading } from "../button-loading";
import { ButtonInStore } from "../button-in-store";
import { ButtonCreativeGlass } from "../button-creative-glass";
import "./add-to-cart.scss";
import { ButtonTradeAccountOnly } from "../button-trade-account-only";
import ButtonEnquireNow from "../button-enquire-now";

type Props = {
  product: ProductType,
  purchasability: ?ProductPurchasability,
  isPricingAvailable: boolean,
  isLoadingPurchasability: boolean,
  isLoggedInUser: boolean
};

class AddToCart extends Component<Props> {
  render() {
    return (
      <div className="wishlist-tile__actions-group wishlist-tile__actions-group--no-comp ">
        {this.props.isLoadingPurchasability ? (
          <ButtonLoading />
        ) : this.props.purchasability === "IN_STORE_ONLY" ? (
          <ButtonInStore />
        ) : this.props.purchasability ===
          "Check Availability (Creative Glass)" ? (
          <ButtonCreativeGlass />
        ) : this.props.purchasability === "Add" ? (
          <ButtonAddToCart
            product={this.props.product}
            isPricingAvailable={this.props.isPricingAvailable}
          />
        ) : this.props.purchasability === "Enquire" ? (
          <ButtonEnquireNow
            productDetailsUrl={this.props.product.productDetailsUrl}
          />
        ) : this.props.isLoggedInUser ? (
          <ButtonTradeAccountOnly />
        ) : (
          <ButtonShopInMax
            secureProductDetailsUrl={this.props.product.secureProductDetailsUrl}
          />
        )}
      </div>
    );
  }
}

export default AddToCart;
